module.exports = __webpack_public_path__ + "files/59e9fe582eede7dd3d252b10ee8595ac.png";